import './style/serviceSlider.css';
import { useEffect } from 'react'
import SliderWrapper from '../utils/SliderWrapper'
import { getCleanerSub } from '../../actions';
import { connect } from 'react-redux';
const CleanerSlider = (props) => {
    const {id, slug} = props.cleaner
    // const [loading, setLoading] = useState(true)
    const { getCleanerSub } = props
    useEffect(() => {
       if (id && slug){
           getCleanerSub(id, slug)
       }
        
    }, [id, slug, getCleanerSub])

    // return  <SliderWrapper height={props.mobileNav ? '160px' : '180px'} sliderItemData={props.cL} heading="Cleaning Services" to={`/services/${slug}`} extraInnerWidth={0} loading={loading} setLoading={setLoading}/>           
    return  <div className="slider-main__container"><SliderWrapper height={props.mobileNav ? '148px' : '180px'} sliderItemData={props.cL} heading="Cleaning Services" to={`/services/${slug}`} extraInnerWidth={0}/></div>
}
const mapStateToProps = (state) => {
    let cleaner = {};
    if (!state.EmployeeCategory.loading){
        state.EmployeeCategory.data?.forEach(x => {
            if (x.slug === 'cleaner'){
                cleaner.id = x.id
                cleaner.slug = x.slug
            }
            
        })
    }
    let cL = state.cL.data.filter(x => x.id !== 18)
    return{
        cleaner: cleaner,
        cL: cL,
        mobileNav: state.mobileNav
    }
}

export default connect(mapStateToProps, { getCleanerSub })(CleanerSlider)